enum LisioBroadcastChannelMessagesNames {
  BCMS_GO_BACK = "bcms_go_back",
  BCMS_ON_CLICK = "bcms_on_click",
  BCMS_ON_CHANGE = "bcms_on_change",
  BCMS_SCROLL_TO = "bcms_scroll_to",
  BCMS_NAV_RESPONSE = "bcms_nav_response",
  BCMS_READY = "bcms_ready",

  BCMR_ANYONE_THERE = "bcmr_anyone_there",
  BCMR_MODIFIED_TEXT = "bcmr_modified_text",
  BCMR_NEW_NODES = "bcmr_new_nodes",
  BCMR_REMOVE_NODES = "bcmr_remove_nodes",
  BCMR_NEW_IMAGE = "bcmr_new_image",
  BCMR_REFRESH_CALENDAR = "bcmr_refresh_calendar",
  BCMR_INIT_HTML = "bcmr_init_html",
  BCMR_CLOSE = "bcmr_close",
  BCMR_NAVIGATE = "bcmr_navigate",
  BCMR_EXIT = "bcmr_exit",
  BCMR_LOAD_PDF = "bcmr_load_pdf",
  BCMR_OPEN_DROPDOWN = "bcmr_open_dropdown",
  BCMR_CLOSE_DROPDOWN = "bcmr_close_dropdown",
}

export default LisioBroadcastChannelMessagesNames;
